export default "__VITE_ASSET__DWVBoJBP__"